import { Observable, of } from 'rxjs';
import { tap, map, switchMap } from 'rxjs/operators';
import { inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Route, Router, UrlTree } from '@angular/router';
import { Store } from '@ngxs/store';
import { Navigate } from '@ngxs/router-plugin';
import { Rtl2SsoService } from '@rtl2/sso';
import { routeNames } from '@shared/models';
import { SetAuthorized } from '@shared/store/shared.actions';
import { CheckProducerRole } from '@app/store/portal.actions';

export const SharedAuthCanMatch = (
  route: Route
): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> => {
  const document = inject(DOCUMENT);
  const router = inject(Router);
  const store = inject(Store);
  const sso = inject(Rtl2SsoService);

  const checkUserRoles = (roles: string[]): Observable<boolean> => {
    return sso.checkRoleObserve(roles).pipe(
      tap((hasRoles) => {
        store.dispatch(new CheckProducerRole());
        store.dispatch(new SetAuthorized(!!hasRoles));
        hasRoles ||
          store.dispatch(
            new Navigate(['/', routeNames.noRights], { missingRole: roles.join(', ') })
          );
      }),
      map((hasRoles) => {
        sso.setHasUserAppRoles(!!hasRoles);
        return !!hasRoles;
      })
    );
  };

  const { href, origin } = document?.location;
  const url = href?.replace(origin, '');

  return sso
    .validateForRoute(url || router.routerState.snapshot.url)
    .pipe(switchMap((r) => (r ? checkUserRoles(route?.data?.roles) : of(false))));
};
